import { createSelector } from 'react-sweet-state';
export var selectReadyPublicDataForOnInit = createSelector(function (state) {
  return state.formData;
}, function (state) {
  return state.numberOfSupportedFields;
}, function (state) {
  return state.screenTabs;
}, function (state) {
  return state.experienceDataIsLoading;
}, function (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading) {
  if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) {
    return {
      formData: formData,
      screenTabsData: screenTabsData
    };
  }
  return null;
});